import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { SET_HORIZONTAL_INPUT, SET_LAST_INPUT_CHANGE_RECORD, SET_SERIES_TYPE_DISABLE_FLAG, SET_VERTICAL_INPUT, SelecrSeriesStore, SelectActiveSeriesIndex, SelectActiveSeriesPartIndex, SelectHorizontalInput, SelectIsMulti, SelectSeriesType, SelectSeriesTypeDisableFlag, selectRemainingTasks } from '../../../../redux/1d-slice/seriesSlice1d';

function HorizontalInputContainer({ horizontalInputRefs, verticalInputaRefs, inputRefs }) {
  const dispatch = useDispatch()
  let horizontalInput = useSelector(SelectHorizontalInput)
  let seriesStore = useSelector(SelecrSeriesStore)
  let activeSeriesIndex = useSelector(SelectActiveSeriesIndex)
  let activeSeriesPartIndex = useSelector(SelectActiveSeriesPartIndex)
  let seriesType = useSelector(SelectSeriesType)
  let seriesTypeDisableFlag = useSelector(SelectSeriesTypeDisableFlag)
  let isMulti = useSelector(SelectIsMulti);

  useEffect(() => {
    dispatch(SET_HORIZONTAL_INPUT(new Array(10).fill()))
    dispatch(SET_VERTICAL_INPUT(new Array(10).fill()))
  }, [activeSeriesIndex, activeSeriesPartIndex])

  let inputChange = (value, index) => {
    let inputArray = [];

    for (let i = index; i < 100; i += 10) {
      let field = seriesStore[activeSeriesIndex].seriesAllfield[activeSeriesPartIndex][i];

      if (seriesType === 'Even') {
        if (!seriesTypeDisableFlag) {
          dispatch(SET_SERIES_TYPE_DISABLE_FLAG(true));
        }
        if (i % 2 === 0) {
          field.setHorigentalValue(value || 0);
          inputArray.push(field);
        }
      } else if (seriesType === 'Odd') {
        if (!seriesTypeDisableFlag) {
          dispatch(SET_SERIES_TYPE_DISABLE_FLAG(true));
        }
        if (i % 2 !== 0) {
          field.setHorigentalValue(value || 0);
          inputArray.push(field);
        }
      } else {
        field.setHorigentalValue(value || 0);
        inputArray.push(field);
      }
    }

    // ✅ Apply to all selected parts when isMulti
    if (isMulti) {
      seriesStore[activeSeriesIndex].AllSeriesPartName.forEach((part, partIdx) => {
        if (part.active && partIdx !== activeSeriesPartIndex) {
          inputArray.forEach((field) => {
            seriesStore[activeSeriesIndex].seriesAllfield[partIdx][field.index].setHorigentalValue(field.horigetalValue);
          });
        }
      });
    }

    let updateHorizontalValue = [...horizontalInput];
    updateHorizontalValue[index] = value;
    dispatch(SET_HORIZONTAL_INPUT(updateHorizontalValue));
    dispatch(
      SET_LAST_INPUT_CHANGE_RECORD({
        activeSeriesIndex,
        activeSeriesPartIndex,
        input: inputArray
      })
    );
  };

  let horizontalInputFocusChange = (e, i) => {
    let { key } = e
    if (key === 'ArrowLeft') {
      horizontalInputRefs.current[i - 1]?.focus();
    } else if (key === 'ArrowRight') {
      horizontalInputRefs.current[i + 1]?.focus();
    } else if (key === 'ArrowDown') {
      inputRefs.current[i]?.focus();
    }
  }

  return (
    <>
      <React.Fragment>
        <td>
          <input
            style={{height:"30px", width:'100%',   color: 'black', backgroundColor: '#c0504c', textAlign: 'center',
                  border: '1px solid #000',  }}
            placeholder="Block"
            disabled
          />
        </td>
        {horizontalInput.map((value, index) => {
          let bgColor = '#c0504c';
          
          if (seriesType === 'Odd' && index % 2 !== 0) bgColor = '#01b0f1';
          if (seriesType === 'Even' && index % 2 === 0) bgColor = '#ffc000';

          return (
            <td key={index}>
              <input
                style={{
                  height:"30px", width:'100%',
                  backgroundColor: bgColor,
                  color: 'black',
                  textAlign: 'center',
                  border: '1px solid #000',
                }}
                type="text"
                value={value || ''}
                onChange={(e) => {
                  const v = e.target.value;
                  if (+v > 0 && v.length <= 3) inputChange(Number(v), index);
                  else if (!v) inputChange("", index);
                }}
                placeholder={index === 0 ? `X${index}` : `X${index}`}
                ref={(el) => (horizontalInputRefs.current[index] = el)}
                onFocus={() => horizontalInputRefs.current[index].select()}
              />
            </td>
          );
        })}

      </React.Fragment>
    </>
  )
}

export default HorizontalInputContainer